import React, { Component } from 'react';
import '../../css/App.css';
import { observer } from 'mobx-react';
import CardPageTitle from '../ShareComponent/CardPageTitle'
import CardDonateUse from './CardDonateUse'
import CardGeneralInformation from './CardGeneralInformation'
import CardCaptcha from './CardCaptcha'
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import appStore from '../../store/AppStore'



const styles = {
  buttonArea:{
    display: "flex",
    alignItem: "center",
    justifyContent: "center",
    padding: "25px 0 10px"
  },
  button:{    
    color: '#FFF',  
    fontSize: "16px",
    width: "100px",
    display: "block",
    letterSpacing: "3px"
    
  }
}

class DonateForm extends Component {
  

  handleSummitClick=()=>{
    appStore.summitData()
  }


  render() {
    const { classes } = this.props;

    return (
      <div className="DonateForm DonateContent">
      
        <CardPageTitle pageTitle1="醫療財團法人辜公亮基金會和信治癌中心醫院" pageTitle2="【贊助本院捐款】"/>  
        <CardDonateUse/>  
        <CardGeneralInformation/> 
        <CardCaptcha/>  
        <div className={classes.buttonArea}>
          <Button 
          variant="contained" 
          color="primary" 
          className={classes.button}
          onClick={this.handleSummitClick}
          >
            送出
          </Button>
        </div> 
        <form id="CTBCForm" name="CTBCForm" method="post" action="https://epos.chinatrust.com.tw/auth/SSLAuthUI.jsp">
            <input type="hidden" name="merID" value={appStore.postCTBCData.merID} />
            <input type="hidden" name="URLEnc" value={appStore.postCTBCData.URLEnc} />
        </form>      
      </div>
    );
  }
}

export default withStyles(styles)(observer(DonateForm));
